export default __webpack_public_path__ + "static/media/chigo-screenshot-03.37f6a124.png";